import { SyntheticEvent } from "react";
import { cloudSyncImage } from "./images/cloudSyncImage";

export const handleImgError = ({
  currentTarget,
}: SyntheticEvent<HTMLImageElement, Event>) => {
  currentTarget.onerror = null; // prevents looping
  currentTarget.src = cloudSyncImage;
};
